import React, { Component } from 'react'
import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/vi';
import MainCommentBox from './MainCommentBox';
import CommentLine from './CommentLine';
import { withTranslation } from 'react-i18next';
import DefaultAvatar from '../../../assets/images/default-avatar.png';

class GiftCommentLine extends Component {
    constructor(props) {
        super(props);
        this.toogle = this.toogle.bind(this);
    }

    toogle() {
        const {commentLv1Id} = this.props;

        if(this.props.commentLv1Id != null) {
            this.props.toggle(commentLv1Id); 
        } else {
            this.props.toggle(this.props.comment.key); 
        }
       
    }


    fixUserProfileDomain(userProfile) {
        if (!userProfile) return userProfile;
        return userProfile.replace("http://", window.location.protocol + '//');
    }

    render() {
        const { comment, recording, user, toggleComment, toggleCommentId, t} = this.props;
        const userId = comment.userId;
        const fbAvatar = comment.userProfile ? this.fixUserProfileDomain(comment.userProfile) : DefaultAvatar;
        const fbName = comment.userName;
        const giftUrl = comment.giftUrl;
        const giftNoItem = comment.giftNoItem;
        const commentId = comment.key;
        const dateTime = comment.dateTime/1000;
        const handleAvatarError = (event) => {
            event.target.onerror = null;
            event.target.src = DefaultAvatar;
        };
        const isChild = !!this.props.commentLv1Id;
        const commentThreadClass = [
            "comment-thread",
            "comment-thread--gift",
            isChild ? "comment-thread--child" : ""
        ].join(" ").trim();
        const replyButtonProps = user == null ? { "data-toggle": "modal", "data-target": "#loginDialog" } : {};

        const handleUserClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            const url = global.config.apiDomain + '/admin/account-manager?id=' + userId;
            window.open(url, '_blank');
        };

        return (
            <div data-userid={userId} data-commentid={commentId} className={commentThreadClass}>
                <div className="comment-thread__avatar">
                    <a href={global.config.apiDomain + '/admin/account-manager?id=' + userId} onClick={handleUserClick} style={{ cursor: 'pointer' }}>
                        <img className="_1ci img" src={fbAvatar} alt="" onError={handleAvatarError} />
                    </a>
                </div>
                <div className="comment-thread__content">
                    <div className="comment-bubble">
                        <div className="comment-bubble__author-row">
                            <a href={global.config.apiDomain + '/admin/account-manager?id=' + userId} onClick={handleUserClick} className="comment-bubble__author" style={{ cursor: 'pointer' }}>
                                {fbName}
                            </a>
                            <span className="comment-bubble__badge">Gift</span>
                        </div>
                        <div className="comment-bubble__text comment-bubble__text--gift">
                            <img src={giftUrl} alt="gift" />
                            <p>x{giftNoItem}</p>
                        </div>
                    </div>
                    <div className="comment-thread__actions">
                        <button
                            type="button"
                            className="comment-thread__action"
                            onClick={this.toogle}
                            {...replyButtonProps}
                        >
                            {t("recording_page.reply", "Trả lời")}
                        </button>
                        <span className="comment-thread__dot">·</span>
                        <span className="comment-thread__time">
                            <Moment unix fromNow tz="Asia/Ho_Chi_Minh" locale="vi">
                                {dateTime}
                            </Moment>
                        </span>
                    </div>
                    {comment.childs != null ? 
                        (comment.childs.map(e => (
                            <CommentLine 
                                    commentLv1Id={commentId} 
                                    key={e.key} 
                                    comment = {e} 
                                    recording={recording} 
                                    user={user}
                                    toggleComment ={toggleComment}
                                    toggleCommentId = {toggleCommentId}
                                    toggle={this.toogle}
                                    ></CommentLine>
                        ))) : 
                        ('')
                    }

                    {(toggleComment == true && toggleCommentId == commentId) ?
                        (<MainCommentBox 
                                recording={recording} 
                                user={user} 
                                commentLv1Id={commentId} 
                                addNewComment={this.props.addNewComment} 
                                ></MainCommentBox>) : 
                        ('')
                    }
                </div>
            </div>
        )
    }
}
export default withTranslation()(GiftCommentLine)
